var render = function render(){var _vm=this,_c=_vm._self._c;return _c('STopicWrapper',_vm._b({},'STopicWrapper',_vm.$attrs,false),[(_vm.contentImg.src)?_c('img',{staticClass:"content-img",style:(_vm.contentImgStyle),attrs:{"src":_vm.contentImg.src,"alt":""}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }